<template>
  <div class="home container p-0">
    <div class="row p-0">
      <div class="col-12">
        <HelloWorld />
      </div>
      <div class="col-12">
        <Testimonials />
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';
import Testimonials from '@/components/Testimonials.vue';

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    Testimonials
  }
};
</script>

<style scoped>
.home {
  background: #f5f5f5;
}
</style>
